// import Vue from 'vue'

window.Cookie = require('js-cookie');
window.Velocity = require('velocity-animate');
// window.Vue = Vue

require('waypoints/lib/noframework.waypoints.min.js');

/*=============================
=          Initialize         =
=============================*/

window.body = document.body;
window.hero = document.getElementById('hero');
window.main = document.querySelector('main');
window.footer = document.getElementById('footer');
window.header = document.getElementById('header');
window.headerHeight = header.offsetHeight;
window.topbar = document.getElementById('topbar');
window.topbarHeight = topbar ? topbar.offsetHeight : 0;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.Promise = require('promise-polyfill').default;

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

var token = document.head.querySelector('meta[name="csrf-token"]');

if(token)
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
else
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');

/*=============================
=      Check Window Width     =
=============================*/

window.checkWidth = function checkWidth(width) {
    return window.innerWidth < width;
};

/*=============================
=       Lazyload Scripts      =
=============================*/

window.scriptWaypoint = function scriptWaypoint(el, src, offset) {
    var scriptWaypoint = new Waypoint({
        element: el,
        handler: function(direction) {
            addJS(src);

            this.destroy();
        },
        offset: offset
    });
};

window.addJS = function addJS(src) {
    var script = document.createElement('script');

    script.src = src;
    script.type = 'text/javascript';
    script.setAttribute('async', 'true');
    script.setAttribute('defer', 'true');

    document.body.appendChild(script);
};

/*=============================
=       Scroll To Element     =
=============================*/

window.scrollToElement = function scrollToElement(scrollTo) {
    Velocity(scrollTo, 'scroll', {duration: 800, offset: -(headerHeight)});
};

/*=============================
=           Map Styles        =
=============================*/

 window.mapStyles = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#494949"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "saturation": "-100"
            },
            {
                "weight": "1"
            },
            {
                "lightness": "0"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#b9b9b9"
            },
            {
                "visibility": "on"
            }
        ]
    }
];